import {Navigate, Outlet, useLocation} from 'react-router'
import {authService} from '~/initializers/auth'
import {useHasRole} from '~/hooks'

export const ProtectedRoute = ({redirectPath = '/login', children, enableRole}) => {
	const hasAuth = authService.checkAuth()
	const hasRole = useHasRole(enableRole)
	const location = useLocation()

	if (!hasAuth) return <Navigate to={redirectPath} replace state={{path: location.pathname}} />

	if (enableRole && !hasRole) return <Navigate to="/" replace />

	return <Outlet />
}
